import { render } from "./FortuneWheel.vue?vue&type=template&id=b3e23f56&scoped=true"
import script from "./FortuneWheel.vue?vue&type=script&lang=js"
export * from "./FortuneWheel.vue?vue&type=script&lang=js"

import "./FortuneWheel.vue?vue&type=style&index=0&id=b3e23f56&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3e23f56"]])

export default __exports__